import React, { useCallback } from "react";
import { FiShare2 } from "react-icons/fi";
import PeopleListPage from "./components/PeopleListPage";
import { useNetworkPermissions, useNetworkService } from "./hooks/useNetworkRecords";
import { PARTNERS_HOME } from "./constants/networkEndpoints";

const CONFIG = {
  noun: "Partner",
  plural: "Partners",
  icon: FiShare2,
  home: PARTNERS_HOME,
  description: "Partners you have added to your network. Only partners added by your account appear here.",
  searchLabel: "Search partners",
  emptyHint: "Add your first partner to start building your network.",
  storageKey: "network-partners",
  canEditRecords: true,
};

/** /partner/network/partners - the logged-in partner's network (same endpoint as the mobile Network tab) */
const PartnersPage = () => {
  const service = useNetworkService();
  const permissions = useNetworkPermissions();
  const load = useCallback(() => service.listPartners(), [service]);
  const remove = useCallback((id) => service.removePartner(id), [service]);

  return <PeopleListPage config={CONFIG} load={load} remove={remove} permissions={permissions} />;
};

export default PartnersPage;
